import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import {
    VENDOR_CONFIRM_RESET_TOKEN_REQUEST,
    VENDOR_FORGOT_PASSWORD_REQUEST,
    VENDOR_RESET_PASSWORD_REQUEST,
} from "./type";
import {
    vendorConfirmResetTokenSuccess,
    vendorForgotPasswordSuccess,
    vendorResetPasswordSuccess,
} from "./action";
import { ApiResponseMessage } from "../../../../helper/tosterHelper";
import { DANGER, SUCCESS } from "../../../../constant/commonConstants";
import { invokeApi } from "../../../../helper/axiosHelper";


function* forgotPassword({ payload: data }) {
    try {
        const res = yield call(invokeApi, "post", "/forgotPassword", data, {}, "vendor");
        yield put(vendorForgotPasswordSuccess(res));
        ApiResponseMessage(res.message, res.status ? SUCCESS : DANGER);
    } catch (error) {
        ApiResponseMessage(error.message, DANGER);
    }
}


function* confirmResetPasswordToken({ payload: token }) {
    try {
        const res = yield call(
            invokeApi,
            "get",
            `/confirmResetPasswordToken/${token}`,
            null,
            {},
            "vendor"
        );
        yield put(vendorConfirmResetTokenSuccess(res));
        if (!res.status) {
            ApiResponseMessage(res.message, DANGER);
        }
    } catch (error) {
        ApiResponseMessage(error.message, DANGER);
    }
}


function* resetPassword({ payload: data }) {
    try {
        const res = yield call(invokeApi, "post", "/resetPassword", data, {}, "vendor");
        yield put(vendorResetPasswordSuccess(res));
        ApiResponseMessage(res.message, res.status ? SUCCESS : DANGER);
    } catch (error) {
        ApiResponseMessage(error.message, DANGER);
    }
}

function* watchVendorForgotRequest() {
    yield takeLatest(VENDOR_FORGOT_PASSWORD_REQUEST, forgotPassword);
    yield takeLatest(VENDOR_CONFIRM_RESET_TOKEN_REQUEST, confirmResetPasswordToken);
    yield takeLatest(VENDOR_RESET_PASSWORD_REQUEST, resetPassword);
}

function* VendorForgotSaga() {
    yield all([fork(watchVendorForgotRequest)]);
}

export default VendorForgotSaga;
